module.exports = __webpack_public_path__ + "img/404-error-not-found-edit.acf13663.png";